import { CheckBox } from '@drycut/ui-components';
import { Controller } from 'react-hook-form';

type ControlledCheckProps = {
  label: string;
  name: string;
};

export function ControlledCheckBox({ name, label }: ControlledCheckProps): React.ReactElement {
  return (
    <Controller
      name={name}
      render={({ field: { value, onChange } }) => (
        <CheckBox checked={value} onChange={onChange} name={name} label={label} />
      )}
    />
  );
}
